var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.label,"value":_vm.item,"readonly":true,"dense":true,"disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }